'use client';
import React, { useEffect, useRef } from 'react';

const painCards = [
  {
    icon: '📊',
    title: 'Datos duplicados y desactualizados',
    body: 'Cada lunes es un caos. Nadie tiene la misma información. Los errores cuestan ventas.',
  },
  {
    icon: '💬',
    title: 'Leads perdidos sin seguimiento',
    body: 'Un mensaje sin responder a tiempo es una venta que se va a la competencia. Sin historial, sin sistema, sin control.',
  },
  {
    icon: '🧩',
    title: '6 herramientas, 6 contraseñas, 0 integración',
    body: 'CRM por un lado. Catálogo por otro. Finanzas en otra hoja. Nadie en tu equipo sabe qué está pasando.',
  },
];

export default function DriveXPainPoints() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.dx-reveal').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 120);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="problema"
      ref={sectionRef}
      className="dx-font"
      style={{ background: '#111111', padding: '100px 0' }}
    >
      <div className="max-w-6xl mx-auto px-6">
        {/* Headline */}
        <div className="text-center mb-12 dx-reveal">
          <h2 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 800, fontSize: 'clamp(28px, 4vw, 44px)', color: '#FFFFFF', letterSpacing: '-0.02em', marginBottom: '12px' }}>
            ¿Cómo estás gestionando tu concesionario hoy?
          </h2>
          <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '16px', color: '#888888' }}>
            Si tu respuesta es "Excel y WhatsApp" — esto es para ti.
          </p>
        </div>

        {/* Pain cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {painCards?.map((card, i) => (
            <div
              key={i}
              className="dx-reveal"
              style={{
                background: '#1A1A1A',
                borderLeft: '3px solid #C8102E',
                borderRadius: '8px',
                padding: '28px 24px',
              }}
            >
              <div style={{ fontSize: '24px', marginBottom: '12px' }}>{card?.icon}</div>
              <h3 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '16px', color: '#FFFFFF', marginBottom: '10px' }}>
                {card?.title}
              </h3>
              <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '13px', color: '#AAAAAA', lineHeight: 1.7 }}>
                {card?.body}
              </p>
            </div>
          ))}
        </div>

        {/* Red callout */}
        <div
          className="dx-reveal"
          style={{ background: '#C8102E', padding: '40px', borderRadius: '8px', textAlign: 'center' }}
        >
          <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '22px', color: '#FFFFFF', letterSpacing: '-0.01em', marginBottom: '10px' }}>
            "El promedio de un concesionario pierde 3 ventas al mes<br />
            por no dar seguimiento a tiempo."
          </p>
          <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
            DriveX elimina ese problema.
          </p>
        </div>
      </div>
    </section>
  );
}
